import { render } from "./NewsletterProfileComponent.vue?vue&type=template&id=5b5d4fe4&scoped=true"
import script from "./NewsletterProfileComponent.vue?vue&type=script&lang=js"
export * from "./NewsletterProfileComponent.vue?vue&type=script&lang=js"

import "./NewsletterProfileComponent.vue?vue&type=style&index=0&id=5b5d4fe4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b5d4fe4"

export default script